import { LocaleEnum } from '@systemeio/ui'
import { PaystackSubAccountInterface } from 'modules/profile/payment-gateways/integrations/paystack/types'

export const getPaystackHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/2531-so-integrieren-sie-paystack-mit-systemeio'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/2565-come-integrare-paystack-con-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2509-how-to-integrate-paystack-with-systeme-io'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/2945-como-integrar-paystack-con-systeme-io'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/2458-comment-integrer-paystack-a-systeme-io'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/3873-como-integrar-o-paystack-com-a-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/2484-how-to-integrate-paystack-with-systeme-io'
    }
  }
}

export const getSubAccountData = (data: PaystackSubAccountInterface[]) => {
  return data.map(subAccount => {
    return {
      id: subAccount.subAccountCode,
      caption: subAccount.businessName,
    }
  })
}
